import { TRootState } from 'Redux/Reducers';

export const getInsuranceCooperationProvider = (state: TRootState) => state.insuranceCooperation.provider;
